import React from 'react';
import './DashboardTable.css'; // Reusing the same CSS

const ScheduleTable = ({ data, headers }) => {

  if (!data || data.length === 0) {
    return <p>No schedule data available</p>;
  }

  // Format date to be more readable
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      console.error('Error formatting date:', error);
      return dateString;
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', height: '50%', width: '100%' }}>
      <div className="custom-table-container">
        <table className="custom-table" style={{ borderSpacing: '0 4px' }}>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index} style={{ padding: '12px 20px' }}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                <td style={{ padding: '10px 20px' }}>
                  {row.barn}
                </td>
                <td style={{ padding: '10px 20px' }}>{row.event}</td>
                <td style={{ padding: '10px 20px' }}>{formatDate(row.date)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ScheduleTable;